// Source: app/scripts/controllers/view-authorization-case.js
Auction.controller('ViewAuthorizationCaseController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$location',
  'toaster',
  'crudService',
  '$modal',
  'Downloader',
  'Messages',
  function ($scope, $filter, $routeParams, $location, toaster, crudService, $modal, Downloader, Messages) {

    var caseService = crudService('cases', {
      'getCase': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/authorization_cases/:id'
      },
      'editAuthorizationCase': {
        method: 'POST',
        url: '/data/rest/authorization_cases/edit_authorization_case'
      },
      'getPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/by_case_id/:id'
      },
      'getOutgoingPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/get_outgoing_documents_for_case_id/:id'
      },
      'getIncomingPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/get_incoming_documents_for_case_id/:id'
      },
      'editPortalDocumentMetadata': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/portal_documents/edit_portal_document'
      },
      'deletePortalDocument': {
        method: 'DELETE',
        url: '/data/rest/portal_documents/:id'
      },
      'getForumMessagesForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/forum/get_forum_messages/:id'
      },
      'saveForumMessage': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/forum_messages'
      },
      'submitAuthorizationCase': {
        method: 'POST',
        url: '/data/rest/authorization_cases/submit_authorization_case'
      },
      'getAuthorizationById': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/authorizations/by_authorization_case_id/:id'
      },
      'getPortalLicenceById': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/portal_licences/by_authorization_case_id/:id'
      },
      'editAuthorization': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/authorizations/edit_authorization'
      },
      'editPortalLicence': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/portal_licences/edit_portal_licence'
      }
    });


    var forumService = crudService('forum', {
        'getForumMessagesForCase': {
          method: 'GET',
          isArray: true,
          url: '/data/rest/forum/get_forum_messages/:id'
        },
        'saveForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        },
        'submitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages/submit_forum_message'
        },
        'deleteForumMessage': {
          method: 'DELETE',
          isArray: false,
          url: '/data/rest/forum_messages/:id'
        },
        'saveAndSubmitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        }

      }
    );


    var authorizationTariffService = crudService('authorization_tariffs', {
      'getAuthorizationTariffsForCaseId': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/authorization_tariffs/by_authorization_case_id/:id'
      },
      'addAuthorizationTariffToAuthorizationCase': {
        method: 'POST',
        url: '/data/rest/authorization_tariffs/add_authorization_tariff_to_authorization_case'
      },
      'deleteAuthorizationTariff': {
        method: 'DELETE',
        url: '/data/rest/authorization_tariffs/:id'
      }
    });


    if ($routeParams && $routeParams.recordsTab) {
      $scope.recordsTab = $routeParams.recordsTab;
    }

    $scope.activateTab = function (rt) {
      var search = {
        recordsTab: rt
      };

      // if($routeParams && $routeParams.tab) {
      //   search.tab = $routeParams.tab;
      // }
      $scope.recordsTab = rt;
      // $location.search(search);
    };


    if ($routeParams && $routeParams.recordsDocumentTab) {
      $scope.recordsDocumentTab = $routeParams.recordsDocumentTab;
    }

    $scope.activateDocumentTab = function (rt) {
      var search = {
        recordsDocumentTab: rt
      };

      // if($routeParams && $routeParams.tab) {
      //   search.tab = $routeParams.tab;
      // }
      $scope.recordsDocumentTab = rt;
      // $location.search(search);
    };


    function loadAuthorizationCaseData(caseId) {
      authorizationTariffService.getAuthorizationTariffsForCaseId({id: caseId}, function (data) {
        $scope.authorizationTariffs = data;
      });
      caseService.getAuthorizationById({id: caseId}, function (data) {
        $scope.authorization = data;
      });
      caseService.getPortalLicenceById({id: caseId}, function (data) {
        $scope.licence = data;
      });
    }

    function initEntity() {

      var portalCase;
      caseService.getCase({id: $routeParams.id}, function (data) {
        portalCase = data;
        $scope.allowEdit = false;
        $scope.entity = {};
        $scope.entity.portalCase = portalCase;
        $scope.forum = portalCase.forum;
        $scope.newForumMessage = {};
        $scope.authorizationTariff = {};

        $scope.chosenDocument = {};
        $scope.portalDocument = {};
        if (portalCase.aboutIndividual) {
          $scope.entity.forCompany = 0;
          $scope.entity.forIndividual = 1;
          $scope.forCompany = 0;
          $scope.forIndividual = 1;
          $scope.individual = portalCase.aboutIndividual;
          console.log('$scope in edit');
          console.log($scope);
        } else {
          $scope.entity.forCompany = 1;
          $scope.entity.forIndividual = 0;
          $scope.forCompany = 1;
          $scope.forIndividual = 0;
          $scope.company = portalCase.aboutCompany;
          // $location.path("/web_portal/web_portal_home_page/create_general_case");
          console.log('$scope in edit');
          console.log($scope);
        }
        $scope.activateTab(1);
        loadAuthorizationCaseData($scope.entity.portalCase.id);
        caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
          $scope.outgoingDocumentList = data;
          $scope.activateDocumentTab(1);
          caseService.getIncomingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
            $scope.incomingDocumentList = data;
            caseService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
              $scope.forumMessagesList = data;
            });
          });
        });
      });
    }


    initEntity();


    $scope.editPortalCaseMetadata = function (portalCase) {
      caseService.editAuthorizationCase(portalCase, function (data) {
        $scope.entity.portalCase = portalCase;
        Messages.saved();
      })
    };


    $scope.downloadDocument = function () {
      if ($scope.chosenDocument.id) {
        Downloader.download('/data/rest/portal_attachments/get/' + $scope.chosenDocument.id);
      }
    };

    $scope.saveChosenDocumentMetadata = function () {
      if ($scope.chosenDocument.id) {
        caseService.editPortalDocumentMetadata(
          {
            id:  $scope.chosenDocument.id,
            description:  $scope.chosenDocument.description,
            typeId: $scope.chosenDocument.documentType.id
          }, function (data) {
            $scope.chosenDocument = data;
            Messages.saved();
          })
      }
    };


    $scope.outgoingDocumentsIndeks = -1;
    $scope.incomingDocumentsIndeks = -1;
    $scope.chooseOutgoingDocument = function (portalDocument, index) {
      $scope.chosenDocument = portalDocument;
      $scope.outgoingDocumentsIndeks = index;
      $scope.incomingDocumentsIndeks = -1;
    };
    $scope.chooseIncomingDocument = function (portalDocument, index) {
      $scope.chosenDocument = portalDocument;
      $scope.incomingDocumentsIndeks = index;
      $scope.outgoingDocumentsIndeks = -1;
    };




    $scope.modalAddOrEditCaseDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_case_document.html',
      show: false
    });


    $scope.changeAttachmentForDocument = function () {
      if ($scope.chosenDocument.id) {
        $scope.portalDocument = $scope.chosenDocument;
        $scope.modalAddOrEditCaseDocument.show();
      }
    };

    $scope.savePortalDocument = function () {
      caseService.getPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
        $scope.documentList = data;
      });
      $scope.modalAddOrEditCaseDocument.hide();

      $scope.portalDocument = {};

    };

    $scope.showAddNewDocumentForm = function () {
      $scope.portalDocument = {};
      $scope.modalAddOrEditCaseDocument.show();
    };


    $scope.deletePortalDocument = function () {
      console.log('vo delete funkcija $scope');
      console.log($scope);

      if ($scope.chosenDocument.id) {
        caseService.deletePortalDocument({id: $scope.chosenDocument.id}, function () {
          caseService.getPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
            $scope.documentList = data;
            Messages.deleted();
            $scope.chosenDocument = {};
          });
        })
      }

    };

    $scope.saveForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      caseService.saveForumMessage(forumMessage, function (data) {
        caseService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })

    };


    $scope.submitForumMessage = function (forumMessage) {
      forumService.submitForumMessage(forumMessage.id, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };

    $scope.saveAndSubmitForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      forumService.saveForumMessage(forumMessage, function (data) {
        $scope.forumMessage2 = data;
        forumService.submitForumMessage(data.id, function (data) {
          forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
            $scope.forumMessagesList = data;
            $scope.newForumMessage = {};
          });
        });
      });
    };


    $scope.deleteForumMessage = function (forumMessage) {
      forumService.deleteForumMessage({id: forumMessage.id}, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };

    $scope.submitPortalCase = function (id) {

      caseService.submitAuthorizationCase(id, function (data) {
        Messages.saved();
        initEntity()
        // $scope.entity.generalCase = data;
        // $scope.activateTab(3);
        // $scope.modalCreateGeneralCase.hide();
        // $scope.modalEditGeneralCase.show();
      })

    };

    $scope.addAuthorizationTariff = function (authorizationTariff) {
      authorizationTariff.authorizationCase = $scope.entity.portalCase;
      authorizationTariffService.addAuthorizationTariffToAuthorizationCase(authorizationTariff, function (data) {
        authorizationTariffService.getAuthorizationTariffsForCaseId({id: $scope.entity.portalCase.id}, function (data) {
          $scope.authorizationTariffs = data;
          $scope.authorizationTariff = {};
        })
      })
    };

    $scope.removeAuthorizationTariff = function (authorizationTariff) {
      authorizationTariffService.deleteAuthorizationTariff({id: authorizationTariff.id}, function () {
        authorizationTariffService.getAuthorizationTariffsForCaseId({id: $scope.entity.portalCase.id}, function (data) {
          $scope.authorizationTariffs = data;
          Messages.deleted();
        });
      })
    };

    $scope.editCase = function (portalCase) {
      console.log('vo novata edit funkcija');
      caseService.editAuthorizationCase(portalCase, function (data) {
        $scope.entity.portalCase = portalCase;
        Messages.saved();
      })
    };

    $scope.submitCase = function (id) {
      console.log('vo novata submitCase funkcija');
      caseService.submitAuthorizationCase(id, function (data) {
        Messages.saved();
        initEntity()
        // $scope.entity.generalCase = data;
        // $scope.activateTab(3);
        // $scope.modalCreateGeneralCase.hide();
        // $scope.modalEditGeneralCase.show();
      })

    };

    $scope.downloadAuthorizationTypeTemplateAttachment = function (templateId) {
      if(templateId) {
        Downloader.download('/data/rest/portal_attachments/get_authorization_type_template/' + templateId);
      }
    };
    $scope.downloadGoodsTypeTemplateAttachment = function (templateId) {
      if(templateId) {
        Downloader.download('/data/rest/portal_attachments/get_goods_type_template/' + templateId);
      }
    };

  }
]);
